import { useState, useCallback } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import DifferenceSection from './components/DifferenceSection';
import HowItWorksSection from './components/HowItWorksSection';
import WhatIncludedSection from './components/WhatIncludedSection';
import ScenariosSection from './components/ScenariosSection';
import FreePreviewSection from './components/FreePreviewSection';
import PricingSection from './components/PricingSection';
import ExpectationsSection from './components/ExpectationsSection';
import AudienceSection from './components/AudienceSection';
import FinalCTASection from './components/FinalCTASection';
import FormSection from './components/FormSection';
import Footer from './components/Footer';
import StickyWhatsApp from './components/StickyWhatsApp';
import ApprovalModal from './components/ApprovalModal';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = useCallback(() => {
    setModalOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      <Navbar onOpenApprovalModal={openModal} />

      <main>
        <article>
          <HeroSection onOpenApprovalModal={openModal} />
          <ProblemSection />
          <DifferenceSection />
          <HowItWorksSection />
          <WhatIncludedSection />
          <ScenariosSection />
          <FreePreviewSection />
          <PricingSection onOpenApprovalModal={openModal} />
          <ExpectationsSection />
          <AudienceSection />
          <FinalCTASection onOpenApprovalModal={openModal} />
          <FormSection />
        </article>
      </main>

      <Footer onOpenApprovalModal={openModal} />
      <StickyWhatsApp onOpenApprovalModal={openModal} />
      <ApprovalModal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
}